<template>
  <article
    class="card"
    :class="{
      'card--dense': dense,
      'card--outlined': outlined,
      'card--no-padding': noPadding
    }"
  >
    <div
      v-if="hasSlotName('image')"
      class="card__image"
    >
      <slot name="image" />
    </div>

    <header
      v-if="title || hasSlotName('header')"
      class="card__header"
    >
      <slot name="header">
        <h1
          v-if="title"
          class="card__title"
          v-text="title"
        />
      </slot>
    </header>
    <div class="card__body">
      <slot />
    </div>
  </article>
</template>

<script>
export default {
  name: 'TgCard',

  inheritAttrs: false,

  props: {
    title: {
      type: String,
      required: false,
      default: null,
    },
    dense: {
      type: Boolean,
      required: false,
      default: false,
    },
    noPadding: {
      type: Boolean,
      required: false,
      default: false,
    },
    outlined: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style scoped>
.card {
  background-color: var(--light-grey);
  margin: 0 -1rem 2rem;
  overflow: hidden;
}

.card:last-child {
  margin-bottom: 0;
}

.card--outlined {
  border: var(--border-style);
  background-color: transparent;
}

.card__header h1,
.card__header h2,
.card__header h3,
.card__header h4,
.card__header h5,
.card__header h6 {
  margin: 0;
}

.card__header,
.card__body,
.card--dense .card__header,
.card--dense .card__body {
  padding: calc( var(--padding) * 1.5 );
}

.card--outlined .card__header {
  border-bottom: var(--border-style);
  padding-top: calc( var(--padding) * 1 );
  padding-bottom: calc( var(--padding) * 1 );
}

.card__header,
.card--dense:not(.card--outlined) .card__header {
  display: flex;
  padding-bottom: 0;
}

.card__body :last-child {
  margin-bottom: 0;
}

.card:not(.card--outlined) >>> .button--secondary:not(:hover),
.card:not(.card--outlined) >>> .button--text:hover {
  background-color: white;
}

.card:not(.card--outlined) >>> .button--text:hover {
  box-shadow: none;
}

@media (min-width: 36rem) {
  .card {
    border-radius: var(--radius);
    margin-inline: initial;
  }

  .card__header,
  .card__body {
    padding: calc( var(--padding) * 2.85 );
  }

  .card--no-padding {
    border-radius: 0;
  }

  .card--no-padding .card__header,
  .card--no-padding .card__body {
    padding: 0;
  }

  .card__header {
    padding-bottom: 0;
  }

  .card__header + .card__body {
    padding-top: var(--padding);
  }
}
</style>
